import { crudMdActions } from "@/services/crud-md-actions";

const name = "certificates";

export default {
  name,
  ...crudMdActions(name),
};
